var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro-body"},[_c('div',{ref:"alertContainer",staticClass:"page-status-alerts"}),(_vm.getPages.length == 0 && _vm.isPagesLoaded)?_c('Intro-start'):_vm._e(),(_vm.getPages.length && _vm.isPagesLoaded)?_c('Intro-main'):_vm._e(),_c('loading',{attrs:{"active":!_vm.isPagesLoaded,"is-full-page":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }